/* SHOPLECY reveal-on-scroll. Adds .sl-reveal to main-content sections and
   product cards, then reveals them with .sl-in as they enter the viewport.
   Includes a safety pass so nothing can stay hidden if observation fails. */
(function () {
  var root = document.documentElement;
  root.classList.add('sl-anim');

  function revealAll(scope) {
    (scope || document).querySelectorAll('.sl-reveal').forEach(function (el) {
      el.classList.add('sl-in');
    });
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('main .shopify-section, main .product-card').forEach(function (el) {
      el.classList.add('sl-in');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sl-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
  );

  function arm(el, delay) {
    if (el.classList.contains('sl-reveal')) return;
    el.classList.add('sl-reveal');
    if (delay) el.style.setProperty('--sl-delay', delay + 'ms');
    io.observe(el);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('main .shopify-section').forEach(function (section) {
      arm(section, 0);
    });
    (scope || document).querySelectorAll('main .product-card').forEach(function (card, i) {
      arm(card, (i % 8) * 60);
    });
  }

  scan(document);

  /* Pick up cards/sections added later (filters, infinite scroll, quick view) */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node.parentNode || document);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* Safety: never leave content hidden */
  window.setTimeout(function () {
    revealAll(document);
  }, 3000);
})();
